import axios from "axios";
import { serverConfig } from "./serverConstants";
import { store } from "../store";
import { markSessionExpired } from "../reducer/authSlice";

// withCredentials:true tells the browser to attach the HttpOnly auth_token cookie
// on every cross-origin request to the backend. No Authorization header needed.
const instance = axios.create({
  baseURL: serverConfig.url,
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const reqUrl = error.config?.url || "";

    // Don't redirect on /answeredQuestions 401s — legacy behavior preserved.
    if (reqUrl.includes("/answeredQuestions")) {
      return Promise.reject(error);
    }

    // /me is the auth probe itself — a 401 here means "not logged in yet",
    // which is normal on a cold page load. authService.fetchMe handles it
    // by dispatching clearAuth; Routes.js then renders the login page. Redirecting
    // here would cause an infinite reload loop.
    if (reqUrl.endsWith("/me") || reqUrl.includes("/v3/me")) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      store.dispatch(markSessionExpired());
      const isSigninFlow = typeof window !== "undefined" && window.location.pathname.includes("/signin");
      const redirectUrl = isSigninFlow ? "/v2/user/signin" : "/v2/user/login";
      window.location.href = redirectUrl;
    }

    return Promise.reject(error);
  }
);

export default instance;
